import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { injectModels } from "../../../redux/injectModels";
import { AuthService, EventService, InvoiceService } from "../../../services";
import {
  formatAmount,
  formatDateENGB,
  handleConsoleError,
} from "../../../utils/common-methods";
import { Link } from "react-router-dom";
import { Table } from "react-bootstrap";
import { routes } from "../../../constants/routes";
import AutoCompleteDropdown from "../../../components/Common/AutoCompleteDropdown";
import { EventStatus } from "../../../constants/Enum";
import { toast } from "react-toastify";

const InvoiceAdmin = (props) => {
  const [currentPage, setCurrentPage] = useState(0);
  const loginUser = AuthService.getLoginUser();
  const [suggestions, setSuggestions] = useState([]);
  const [eventList, setEventList] = useState([]);
  // const [paginatedData, setPaginatedData] = useState([]);
  const [eventSearchName, setEventSearchName] = useState("All");

  const [filteredData, setFilteredData] = useState([]);

  const rowsPerPage = 10;
  const offset = currentPage * rowsPerPage;
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  useEffect(() => {
    const bootstrapAsync = async () => {
      await getEventData();
      await getAllOrganizerData("");
    };
    bootstrapAsync();
  }, []);

  const getEventData = async () => {
    try {
      if (loginUser) {
        props.application.setLoading(true);
        const res = await EventService.getAllEvents();
        if (res?.isSuccess && res?.data?.length > 0) {
          const eventList = res?.data
            .filter(
              (x) =>
                x.eventStatusId !== EventStatus.Rejected &&
                x.eventStatusId !== EventStatus.Canceled &&
                x.eventStatusId !== EventStatus.Draft
            )
            .map((item) => ({
              eventName: item?.eventName,
              id: item.id,
            }));
          setEventList(eventList);
          setSuggestions(eventList.map((item) => item?.eventName));
        }
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
       const message= handleConsoleError(error);
       toast.error(error?.message|| message);
    }
  };

  // Ticket Transactions  Report
  const getAllOrganizerData = async (id) => {
    props.application.setLoading(true);
    let eventId = "00000000-0000-0000-0000-000000000000";
    if (id && id.length > 5) {
      eventId = id;
    }
    try {
      const res = await InvoiceService.getAllInvoiceAdminReports(eventId);
      if (res?.isSuccess) {
        setFilteredData(res?.data);
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
         //toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
      }
    } catch (error) {
      props.application.setLoading(false);
       const message= handleConsoleError(error);
       toast.error(error?.message|| message);
    }
  };

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };

  const handleSelect = async (selected) => {
    if (selected && selected.length >= 2) {
      setEventSearchName(selected);
      const filetEvent = eventList.filter(
        (item) => item?.eventName?.trim() === selected.trim()
      );
      if (filetEvent?.length > 0) {
        await getAllOrganizerData(filetEvent[0].id);
      }
    } else {
      setEventSearchName("All");
      await getAllOrganizerData("All");
    }
  };

  return (
    <React.Fragment>
      <div className="pagetitle">
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={routes.ADMIN_DASHBOARD}>Dashboard</Link>
            </li>
            <li className="breadcrumb-item active">
              {" "}
              <i className="fa-solid fa-chevron-right"></i>Invoices
            </li>
          </ol>
        </nav>
      </div>
      {/* Search Input */}
      <div className="mb-3">
        <div className="row">
          <div className="col-sm-12">
            <span>Event Name</span>
            <AutoCompleteDropdown
              suggestions={suggestions}
              onSelect={handleSelect}
            />
          </div>
        </div>
      </div>
      {eventSearchName && (
        <React.Fragment>
          <div className="table-responsive">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Invoice No</th>
                  <th>Event Name</th>
                  <th>Invoice To</th>
                  <th>Type</th>
                  <th>Amount (£)</th>
                  {/* <th>Vat (£)</th> */}
                  <th>Invoice Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData && paginatedData.length > 0 ? (
                  <React.Fragment>
                    {paginatedData.map((item, idx) => {
                      return (
                        <tr key={idx}>
                          <td>{calculateSNo(idx)}</td>
                          <td>{item?.invoiceNo}</td>
                          <td>{item?.eventName} </td>
                          <td>{item?.traderLegalBusinessName} </td>
                          <td>
                            {item?.eventApplicationType === "T"
                              ? "Ticket"
                              : item?.eventApplicationType === "C"
                              ? "Caterer"
                              : "Retail Trade Stand"}{" "}
                          </td>
                          <td>£{formatAmount(item?.totalAmount)}</td>
                          {/* <td>£{formatAmount(item?.adminFee)}</td> */}
                          <td>
                            {item?.invoiceDate
                              ? formatDateENGB(item?.invoiceDate)
                              : "-"}
                          </td>
                          <td>
                            {" "}
                            {item?.traderInvoiceURL && (
                              <Link
                                onClick={() =>
                                  window.open(item?.traderInvoiceURL, "_blank")
                                }
                                title="View Trader Invoice"
                                style={{ marginRight: "10px" }}
                              >
                                <i className="fa fa-file-pdf"></i>
                              </Link>
                            )}
                            {item?.platformInvoiceURL && (
                              <Link
                                onClick={() =>
                                  window.open(
                                    item?.platformInvoiceURL,
                                    "_blank"
                                  )
                                }
                                title="View Platform Invoice"
                                style={{ marginRight: "10px" }}
                              >
                                <i className="fa fa-file"></i>
                              </Link>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </React.Fragment>
                ) : (
                  <tr>
                    <td colSpan="10 mt-2">No results found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <div className="table-footer">
            <p className="mb-3">
              <strong>Total Count: {filteredData.length}</strong>
            </p>
            {filteredData.length === 0 ? "" : renderPagination()}
          </div>
        </React.Fragment>
      )}
      {!eventSearchName && <p>Find the invoice by entering the event name.</p>}
    </React.Fragment>
  );
};

export default injectModels(["application"])(InvoiceAdmin);
